import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {  Grid, Link, InputLabel, Select, MenuItem, FormControl, Grid2 } from "@mui/material";

import { useState } from "react";
import firebase from 'firebase/compat/app';
import { collection, getCountFromServer, getFirestore, onSnapshot, getDocs, query, where } from '@firebase/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { doc, setDoc } from "firebase/firestore"; 
import Button from 'react-bootstrap/Button';
import { useEffect } from "react";
import { NumericStepper } from '@anatoliygatt/numeric-stepper';
import NumericInput from 'react-numeric-input';
import { Swiper, SwiperSlide } from "swiper/react";
import ModalListing from "./ModalListing";












export default function NewPatientModal({ listing, onClose }) {


  const [value, setValue] = useState(0);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    borderRadius:3,
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    maxHeight: '100vh',
    p: 4,
    overflowY: "auto"

  };




  return (
    <div>
      <Modal
        onClose={onClose}
        
      >
        <Box sx={style}>
        {/* <SwiperSlide >
            <img
              src={"https://i.ibb.co/xKby3CK/abandoned-old-wood-plank-farm-house-very-bad-condition-149482664.webp"}
              alt={"house"}
              className="swiper-image"
            />
          </SwiperSlide> */}
          
        <Typography align="center"   variant="h5" component="h4">
             Estimated Financials
           </Typography>
        <Typography align="center"  sx={{mb: 0}} variant="h6" component="h4">
             (Monthly)
           </Typography>
        <Grid container rowSpacing={8} spacing={{ xs: 4, md: 4 }} columns={{ xs: 4, sm: 8, md: 12 }} >
           
            <Grid item xs={2} sm={4} md={4}>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Prop Mgmt</h3>
            
          </Typography>
          <Grid item xs={2} sx={{mb:4}} align={'center'} >
            <NumericInput mobile  min={0} max={1000000} value={137.8} step={0.1} precision={2}/>
            </Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Utilities</h3>
            
          </Typography>
          <Grid item xs={2} sx={{mb:4}} align={'center'} >
            <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/>
            </Grid>
            
            
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Prop Taxes</h3>
            
          </Typography>
          <Grid item xs={2} align={'center'}sx={{mb:4}}>
            <NumericInput mobile  min={0} max={10000000} value={158.42} step={0.1} precision={2}/>
            </Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Vacancy Reserve</h3>
            
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
            <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/>
            </Grid>
            
           
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Insurance</h3>
            
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
            <NumericInput mobile  min={0} max={10000000} value={75} step={0.1} precision={2}/>
            </Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Maintenance Res</h3>
            
          </Typography>
          <Grid item xs={2} align={'center'} >
            <NumericInput mobile  min={0} max={1111000} value={0} step={0.1} precision={2}/>
            </Grid>
            
            </Grid>
            {/* <Grid item xs={2} align={'center'} >
            <NumericInput mobile  min={0} max={100} value={50} step={0.1} precision={2}/>
            </Grid>
            <Grid item xs={2} align={'center'} >
            <NumericInput mobile  min={0} max={100} value={50} step={0.1} precision={2}/>
            </Grid> */}
            
            
            
          </Grid>

          <Typography align="center"  sx={{mt: 3}} variant="h5" component="h4">
             Cashflow Calculation
           </Typography>
        <Typography align="center"  sx={{mb: 0}} variant="h6" component="h4">
             (Monthly)
           </Typography>
           <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
           
            <Grid item xs={2} sm={4} md={4}>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Down Payment (%)</h3>
            
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
            <NumericInput mobile  min={0} max={10000000} value={20} step={0.1} precision={2}/>
            </Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Closing Costs (%)</h3>
            
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
            <NumericInput mobile  min={0} max={10000000} value={2} step={0.1} precision={2}/>
            </Grid>
            
            
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Down Payment($)</h3>
            
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
            <NumericInput mobile  min={0} max={10000000} value={18000} step={0.1} precision={2}/>
            </Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Interest Rate (%)</h3>
            
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
            <NumericInput mobile  min={0} max={1000000} value={6.5} step={0.1} precision={2}/>
            </Grid>
            
           
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Closing Costs (%)</h3>
            
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
            <NumericInput mobile  min={0} max={10000000} value={1800} step={0.1} precision={2}/>
            </Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'}>Term (Years)</h3>
            
          </Typography>
          <Grid item xs={2} align={'center'} >
            <NumericInput mobile  min={0} max={10000000} value={30} step={0.1} precision={2}/>
            </Grid>
            
            </Grid>
            
            
            
            
          </Grid>
          
        
        </Box>

        {/* <Typography>

        <h1>Hi</h1>
        </Typography> */}
        
       
      
        
      </Modal>
    </div>
  );
}